import LoaderHOCContainer from './LoaderHOCContainer';

export default LoaderHOCContainer;



// WEBPACK FOOTER //
// ./src/components/atoms/LoaderHOC/index.js